import { requestErpApi } from './erpSessionClient';

export function registryDigits(value) {
  return String(value == null ? '' : value).replace(/\D/g, '');
}

function cnpjCheckDigit(base, weights) {
  const total = weights.reduce((sum, weight, index) => (
    sum + Number(base[index]) * weight
  ), 0);
  const remainder = total % 11;
  return remainder < 2 ? 0 : 11 - remainder;
}

export function isValidCnpj(value) {
  const normalized = registryDigits(value);
  if (!/^\d{14}$/.test(normalized) || /^(\d)\1{13}$/.test(normalized)) return false;
  const first = cnpjCheckDigit(normalized, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  const second = cnpjCheckDigit(
    `${normalized.slice(0, 12)}${first}`,
    [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  );
  return normalized.endsWith(`${first}${second}`);
}

export async function lookupPublicCnpj(value) {
  const cnpj = registryDigits(value);
  if (!isValidCnpj(cnpj)) {
    const error = new Error('Informe um CNPJ valido com 14 digitos.');
    error.code = 'invalid_cnpj';
    throw error;
  }
  return requestErpApi(`/cloud/lookups/cnpj/${cnpj}`);
}

export async function lookupPublicCep(value) {
  const cep = registryDigits(value);
  if (!/^\d{8}$/.test(cep)) {
    const error = new Error('Informe um CEP valido com 8 digitos.');
    error.code = 'invalid_cep';
    throw error;
  }
  return requestErpApi(`/cloud/lookups/cep/${cep}`);
}

export function mergeEmptyRegistrationFields(current, patch) {
  const next = { ...current };
  for (const [field, value] of Object.entries(patch || {})) {
    const normalized = String(value == null ? '' : value).trim();
    if (!normalized) continue;
    if (!String(current?.[field] == null ? '' : current[field]).trim()) {
      next[field] = normalized;
    }
  }
  return next;
}

export function cnpjRegistrationPatch(data) {
  const address = data?.endereco || {};
  const activity = data?.cnaePrincipal || {};
  return {
    nome: data?.razaoSocial,
    razao_social: data?.razaoSocial,
    nome_fantasia: data?.nomeFantasia,
    inscricao_estadual: data?.inscricaoEstadual,
    email: data?.email,
    email_contato: data?.email,
    telefone: data?.telefone,
    telefone_contato: data?.telefone,
    endereco: address.logradouro,
    logradouro: address.logradouro,
    numero: address.numero,
    numero_endereco: address.numero,
    complemento: address.complemento,
    complemento_endereco: address.complemento,
    bairro: address.bairro,
    bairro_endereco: address.bairro,
    cep: address.cep,
    cidade: address.cidade,
    municipio: address.cidade,
    uf: address.uf,
    codigo_municipio: address.codigoMunicipio,
    cnae: activity.formatado || activity.codigo,
    cnae_descricao: activity.descricao
  };
}

export function cepRegistrationPatch(data) {
  return {
    endereco: data?.logradouro,
    logradouro: data?.logradouro,
    complemento: data?.complemento,
    complemento_endereco: data?.complemento,
    bairro: data?.bairro,
    bairro_endereco: data?.bairro,
    cidade: data?.cidade,
    municipio: data?.cidade,
    uf: data?.uf,
    codigo_municipio: data?.codigoMunicipio
  };
}

export function lookupFeedback(error, kind) {
  if (!error) return '';
  if (error.code === `${kind}_not_found`) {
    return kind === 'cnpj' ? 'CNPJ não encontrado.' : 'CEP não encontrado.';
  }
  if (error.code === 'cnpj_lookup_rate_limited') {
    return 'Limite público de CNPJ atingido. Aguarde um minuto e tente novamente.';
  }
  return kind === 'cnpj'
    ? 'Não foi possível consultar o CNPJ agora; você pode preencher manualmente.'
    : 'Não foi possível consultar o CEP agora; você pode preencher manualmente.';
}
